module.exports = __webpack_public_path__ + "img/adform.b9997b7.png";